import Vue from 'vue'
// import VueCookies from 'vue-cookies'
// Vue.use(VueCookies)
import {
  login_getuser
} from '@/network/index.js';

const state = {
  token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {} // 需要管理的状态数据
}

const mutations = {
  SET_USER(state, user_obj) { //写入用户数据
    localStorage.setItem('user', user_obj);
    state.user = JSON.parse(user_obj);
    // Vue.$cookies.set("user",user_obj,-1);
  },
  SET_TOKEN(state, token) { //写入token数据
    localStorage.setItem('token', token);
    state.token = token;
    // Vue.$cookies.set("token",token,-1);
  },
  EXIT_LGOIN(state) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    state.token = '';
    state.user = '';
    // Vue.$cookies.remove('user')
    // Vue.$cookies.remove('token')
  },
  // =======================================
  SET_LANG(state, lang) { //写入用户选择专业和科目信息
    localStorage.setItem('lang', lang);
    state.lang = lang;
  }
}
const getters = {
  GET_USER(state) {
    return state.user;
  },
  GET_TOKEN(state) {
    return state.token;
  },
  GET_LANG() {
    return state.lang;
  }
}
const actions = {
  USER_REFRESH({ //刷新用户数据
    commit,
    state
  }) {
    login_getuser({
      userId: state.user.userId
    }).then((res) => {
      if (res.code === '0') {
        commit('SET_USER', JSON.stringify(res.data))
        commit('SET_TOKEN', res.data.token)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js